<mx-grid (customize)="onCustomize($event)"></mx-grid>

<ng-template #promoView let-element="element">
    <prl-zone-view [promos]="element.promos"></prl-zone-view>
</ng-template>

<ng-template #generateCodeCell let-row="element">
    <mx-button [buttonModel]="generateCodeBtn"
               (click)="$event.stopPropagation(); generateCodeForZone(row)"></mx-button>
</ng-template>
